import axiosJava from "@/api/config_java";
import { param } from "jquery";
// 客户28天封户数据
export const clientDisabledData = param =>
  axiosJava.get(`/am/api/policyInsights/clientDisabledData`, { params: param });
// 客户DRR分数-曲线图
export const clientDrrFraction = param =>
  axiosJava.get(`/am/api/policyInsights/clientDrrFraction`, { params: param });
//开户公司封户消耗趋势
export const accountCompanyDisabledCost = param => 
  axiosJava.get(`/am/api/policyInsights/accountCompanyDisabledCost`, { params: param });
//开户公司DRR分数-曲线图
export const accountCompanyDrrFraction = param => 
  axiosJava.get(`/am/api/policyInsights/accountCompanyDrrFraction`, { params: param });
  
// 详情-单个开户公司数据
// export const closeAccountCompany = param =>
//   axiosJava.get(`/am/api/policyInsights/closeAccountCompany`, { params: param });

// 详情-开户公司所有的封户数据
// export const closeAccountInfoList = param =>
//   axiosJava.get(`/am/api/policyInsights/closeAccountInfoList`, { params: param });

// 客户28天拒登数据
export const clientDisapprovedData = param =>
  axiosJava.get(`/am/api/policyInsights/clientDisapprovedData`, { params: param });
// 客户LARR分数-曲线图
export const clientLarrFraction = param =>
  axiosJava.get(`/am/api/policyInsights/clientLarrFraction`, { params: param });
//开户公司DRR分数-曲线图
export const accountCompanyLarrFraction = param => 
  axiosJava.get(`/am/api/policyInsights/accountCompanyLarrFraction`, { params: param });
//开户公司拒登消耗趋势
export const accountCompanyDisapprovedCost = param => 
  axiosJava.get(`/am/api/policyInsights/accountCompanyDisapprovedCost`, { params: param });